// extracted by mini-css-extract-plugin
module.exports = {"LargeFontSize":"PrintPrescriptionStyle_LargeFontSize__1uia_"};